import React, { useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled, { css } from "styled-components"
import Slider from "react-slick"
import ReactPlayer from "react-player"
import { Row, Col } from "reactstrap"
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"
import VideoOverlay from "components/shared/VideoOverlay"
import ContainerMax from "components/shared/ContainerMax"
import Button from "components/shared/Button"
import Text from "components/shared/Text"
import CarouselNextButton from "components/shared/CarouselNextButton"
import CarouselPrevButton from "components/shared/CarouselPrevButton"

const SliderStyled = styled(Slider)`
	position: relative;

	.slick-slide {

		> div {
			display: flex;
		}
	}
	.slider-arrow {
		position: absolute;
		background: transparent;
		appearance: none;
		border: none;
		font-size: 30px;
		z-index: 13;
		padding: .25rem;
		color: ${props => props.theme.colors.secondary};
		display: none !important;
		z-index: 10;
		align-items: center;
		justify-content: center;
		height: 30px;
		width: 30px;
		
		@media ${media.md} {
			display: flex !important;
			bottom: auto;
			top: calc(50% + 50px);
			transform: translateY(-50%);
		}
		
		&.prev {
			left: 1rem;
		}
		&.next {
			right: 1rem;
		}
		
		svg {
			max-width: 12px;
			max-height: 24px;
		}
		
		
		&:hover {
			color: ${props => props.theme.colors.secondary};
		}
	}
	.slick-dots {
		display: none!important;
		/* calc height of image responsively */
		/* top: calc((((324 / 576) * 100vw)) - 2.5rem); 
		bottom: auto; */
		/* 
		@media ${media.sm} {
			top: calc((((775 / 992) * 100vw)) - 2.5rem); 
		} */
		
		@media ${media.md} {
			top: auto;
			bottom: 1.5rem;
		}
	}
`

const Slide = styled.div`
	display: block;
	position: relative;
	overflow: hidden;
	line-height: 0;
	@media ${media.md} {
		height: 100%;
		margin-top: 8rem;
	}
	@media ${media.lg} {
		margin-top: 2rem;
	}
	@media ${media.xl} {
		margin-top: 2rem;
	}
	&:after {
		content: "";
		position: absolute;
		z-index: 2;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		background-image: ${props => props.theme.colors.gradientLeft};
		/* display:none; */
		opacity: .85;
		
		/* @media ${media.md} {
			display: block;
		} */
	}
`

const SlideContainerMax = styled(ContainerMax)`
	position: absolute;
	z-index: 10;
	width: 100%;
	bottom: 1rem;
	/* bottom: calc(50% + -5rem); */
	/* bottom: 1.5rem; */
	padding-right: 1.5rem;
	/* padding-left: calc(15px + 2rem); */
	@media (min-width: 400px) {
		bottom: 4rem;
	}
	@media ${media.md} {
		bottom: auto;
		top: calc(50% + 50px);
		left: 50%;
		transform: translate(-50%, -50%);
		padding-left: 30px;
	}
	.slide-button {
		width: 100%;
		text-align: center;
		margin-bottom: .5rem;
		
		span {
			padding: 1rem;
			font-size: .7rem;
		}
		
		@media ${media.sm} {
			width: auto;
		}
		
		@media ${media.md} {
			span {
				font-size: ${props => props.theme.font.size.sm};
				padding: 1rem 2rem;
			}
		}
	}
	
	h1 {
		color: ${props => props.theme.colors.white};
		font-family: ${props => props.theme.font.family.heading};
		//font-style: italic;
		line-height: .9;
		text-transform: uppercase;
		font-size: ${props => props.theme.font.size.xxl};
		@media ${media.md} {
			padding-left: 75px;
		}
		
		@media ${media.xl} {
			font-size: ${props => props.theme.font.size.xxxl};
			padding-left: 85px;
			
		}
		@media ${media.xxl} {
		}
	}
	
	h3 {
		color: ${props => props.theme.colors.secondary};
		font-family: ${props => props.theme.font.family.heading};
		line-height: .9;
		text-transform: uppercase;
		margin-bottom: 2rem;
		font-size: ${props => props.theme.font.size.base};
		line-height: 1.25;
		@media ${media.md} {
			padding-left: 75px;
			
		}
		@media ${media.xl} {
			padding-left: 85px;
		}
		@media ${media.md} {
			font-size: ${props => props.theme.font.size.md};
			line-height: 1.1;
		}
		
		@media ${media.lg} {
			font-size: ${props => props.theme.font.size.lg};
		}
		
		@media ${media.xl} {
			font-size: ${props => props.theme.font.size.xl};
		}
	
		@media ${media.xxl} {
			font-size: ${props => props.theme.font.size.xl};
		}
	}
`

const TextBlock = styled(Text)`
	color: ${props => props.theme.colors.white};
	font-family: ${props => props.theme.font.family.regular};
	font-size: ${props => props.theme.font.size.base};
	padding-bottom: .5rem;
	line-height: 1;
	@media ${media.md} {
      font-size: ${props => props.theme.font.h3.size};
    }
	@media ${media.xl} {
		padding: 1.5rem 0;
	}
`

const VideoWrap = styled.div`
	position: absolute;
	z-index: 1;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 140%;
	height: 140%;
	display: none;
	@media ${media.lg} {
		width: 120%;
		height: 120%;
	}
	.embed-responsive-item {
		width: 100% !important;
		height: 100% !important;
	}
	iframe {
		pointer-events: none;
	}
	@media ${media.md} {
		display: block;
	}
`

const Carousel = (props) => {
	const [videoOverlays, setVideoOverlays] = useState(false)
	const [isBackgroundVideoPlaying, setIsBackgroundVideoPlaying] = useState(false)

	useEffect(() => {
		setVideoStates()
	}, [])

	const setVideoStates = () => {
		let videos = []
		let overlays = []
		let first = 0

		props.slides.forEach((slide, i) => {
			if (slide.backgroundVideo) {
				overlays[i] = false
				first === 0 && window.innerWidth > 767 ? videos[i] = true : videos[i] = false
				first++
			}
		})

		setIsBackgroundVideoPlaying(videos.length > 0 ? videos : false)
		setVideoOverlays(overlays.length > 0 ? overlays : false)
	}

	const onSlide = (current, next) => {
		let videos = [...isBackgroundVideoPlaying]

		if (videos[current] !== undefined) {
			videos[current] = false
		}
		if (videos[next] !== undefined) {
			videos[next] = window.innerWidth > 767 ? true : false
		}

		setIsBackgroundVideoPlaying(videos)
	}

	const toggleVideoOverlay = (e, i) => {
		e.preventDefault()
		let overlays = videoOverlays
		overlays[i] = !videoOverlays[i]

		setVideoOverlays(overlays)
	}

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		draggable: false,
		fade: true,
		autoplay: 0,
		adaptiveHeight: true,
		lazyload: true,
		prevArrow: <CarouselPrevButton/>,
		nextArrow: <CarouselNextButton/>,
		beforeChange: (current, next) => onSlide(current, next)
	}

	if (props.slides) {
		return (
			<SliderStyled {...settings}>
				{props.slides.map((slide, i) => {
					return (
						<React.Fragment key={i}>
							<Slide>
								<GatsbyImage 
									image={slide.imageMobile.localFile.childImageSharp.gatsbyImageData} 
									alt={slide.imageMobile.altText} 
									className="d-md-none"
								/>    
								<GatsbyImage 
									image={slide.imageTablet.localFile.childImageSharp.gatsbyImageData} 
									alt={slide.imageTablet.altText} 
									className="d-none d-md-block d-lg-none"
								/>    
								<GatsbyImage 
									image={slide.imageDesktop.localFile.childImageSharp.gatsbyImageData} 
									alt={slide.imageDesktop.altText} 
									className="d-none d-lg-block"
								/>    
								
								{slide.backgroundVideo &&
									<VideoWrap className="ratio ratio-16x9 d-none d-md-block">
										<ReactPlayer
											url={slide.backgroundVideo}
											playing={isBackgroundVideoPlaying[i]}
											volume={0}
											muted={true}
											controls={false}
											loop={true}
											className="embed-responsive-item"
										/>
									</VideoWrap>
								}
								<SlideContainerMax maxWidth="1600">
									<Row>
										<Col>
											{slide.text !== null &&
												<Text $heroText $secondary dangerouslySetInnerHTML={{ __html: slide.text }} />
											}

											{slide.title &&
												<h1 dangerouslySetInnerHTML={{ __html: slide.title }} />
											}

											{slide.subTitle &&
												<h3 dangerouslySetInnerHTML={{ __html: slide.subTitle }} />
											}

											<Row className="hero-padding">
												{slide.link1 && slide.link1.url !== "" &&
													<Col xs={6} sm="auto">
														<WPLink 
															url={slide.link1.url} 
															target={slide.link1.target} 
															button 
															color="primary" 
															className="slide-button"
														>
															{slide.link1.title}
														</WPLink>
													</Col>
												}
												{slide.link2 && slide.link2.url !== "" &&
													<Col xs={6} sm="auto">
														<WPLink 
															url={slide.link2.url} 
															target={slide.link2.target} 
															button
															color="tertiary"
															className="slide-button"
														>
															{slide.link2.title}
														</WPLink>
													</Col>
												}
												{/*do we have a link to a youtube video?*/}
												{slide.linkVideo &&
													<Col xs={6} sm="auto">
														<Button 
															href="#"
															color="primary" 
															onClick={(e) => toggleVideoOverlay(e, i)}
															className="slide-button"
														>
																<span>Watch</span>
														</Button>
													</Col>
												}
											</Row>
										</Col>
									</Row>
								</SlideContainerMax>
							</Slide>
							{slide.linkVideo && 
								<VideoOverlay 
									url={slide.linkVideo} 
									active={videoOverlays[i]} 
									toggleVideoOverlay={(e) => toggleVideoOverlay(e, i)}
								/>
							}
						</React.Fragment>
					)
				})}
			</SliderStyled>
		)
	} else {
		return ""
	}
}

export default Carousel